import { select } from "d3-selection";
import { nest } from "d3-collection";
import { extent, max, min } from "d3-array";
import { csv } from "d3-fetch";

export default {
    select,
    nest,
    extent,
    min,
    max,
    csv
};